export default __webpack_public_path__ + "static/ladder-4867f9dacdf71a12287890e22076f4cb.png";